import styled from 'styled-components';

import { mediaQuery } from '../../../../../styles/global';

export const Caption = styled.h3`
  font-family: ${({ theme }) => theme.fontFamily.bold};
  color: ${({ theme }) => theme.colors.white};
  font-size: 3.4rem;
  margin: 0;
  line-height: 100%;

  ${mediaQuery.maxWidth.phone} {
    font-size: 2rem;
  }
`;

export const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  padding: 0 20px;
  gap: 40px;
  ${mediaQuery.maxWidth.tablet} {
    flex-direction: column;
  }
  ${mediaQuery.maxWidth.phone} {
    padding: 50px 20px;
    min-height: initial;
  }
`;

export const VisualBlock = styled.div`
  width: 50%;
  display: flex;
  justify-content: flex-start;
  img {
    max-width: 639px;
  }
  ${mediaQuery.maxWidth.tablet} {
    width: 100%;
    max-width: 400px;
  }
`;

export const TextBox = styled.div`
  width: 50%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  flex-grow: 1;
  z-index: 5;
  padding-right: 40px;
  ${mediaQuery.maxWidth.tablet} {
    padding: 0;
    width: 100%;
  }
  ${mediaQuery.maxWidth.phone} {
    top: 0;
    justify-content: center;
  }
`;

export const ButtonWrapper = styled.div`
  ${mediaQuery.maxWidth.tablet} {
    width: 100%;
    a,
    button {
      width: 100%;
    }
  }
`;

export const Description = styled.p`
  line-height: 170%;
  margin: 30px 0;
  font-size: 1.25rem;
  color: rgba(255, 255, 255, 0.75);
  font-family: ${({ theme }) => theme.fontFamily.regular};
`;

export const GradientLeft = styled.img`
  pointer-events: none;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  max-height: 100%;

  ${mediaQuery.minWidth.wide} {
    display: none;
  }
`;
